import $ from "jquery";
import { state } from "../../../../core/settings";
import "./interfaceGroup.scss";

export function interfaceGroupComponent(title = "empty", param = "empty") {
  const componentContent = $(`
        <div class="interface__group">
           <div class="interface__group__head">
             <h2 class="interface__group__head__name">${title}</h2>
             <h2  class="interface__group__head__param">${param}</h2>
           </div>
        </div>
    `);

  componentContent.find(".interface__group__head").on("click", function () {
    const clickedGroup = $(this).closest(".interface__group");
    const relativeItem = clickedGroup.find(".interface__group__inputs");
    const arrowIcon = clickedGroup.find(".interface__group__head__param");

    $(".interface__group").each(function () {
      const relativeItem = $(this).find(".interface__group__inputs");
      const arrowIcon = $(this).find(".interface__group__head__param");
      relativeItem.slideUp(300);
      arrowIcon.removeClass("interface__group__head__param-rotated");
    });

    // Відкриваємо або закриваємо поточний елемент
    if (relativeItem.is(":visible")) {
      relativeItem.slideUp(300);
      arrowIcon.removeClass("interface__group__head__param-rotated");
    } else {
      relativeItem.slideDown(300);
      arrowIcon.addClass("interface__group__head__param-rotated");
    }
  });

  if (title === "Dimensions") {
    setTimeout(() => {
      componentContent.find(".interface__group__inputs").append(``);

      const activeClass = "active";

      //INIT STEEL HEADER
      componentContent.find("#steel").each(function () {
        if (state.midBeam) {
          $(this).addClass(activeClass);
        }

        if (state.wallOption === 4 && !state.roofType) {
          $("#steel").addClass("disable");
        }
      });

      //HANDLE STEEL HEADER
      componentContent.find("#steel").on("click", function () {
        if ($("#steel").hasClass("disable")) {
          return;
        }

        $(this).toggleClass(activeClass);
        state.midBeam = !state.midBeam;

        pergola.update();
      });
    }, 500);
  }

  return componentContent;
}
